import { adminAiConversationQueryKeys as e } from "./adminAiConversationQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { adminAiApi as n } from "@maat/api-ai";
//#region src/ai/admin/useAdminAiConversationsQuery.ts
var r = (r = {}) => {
	let { search: i } = r;
	return t({
		queryKey: e.list(i),
		fetchPage: (e) => n.listConversations({
			search: i,
			page: e
		}),
		key: "items"
	});
};
//#endregion
export { r as useAdminAiConversationsQuery };
